import { ObjectByKey, StringByKey } from '../types/common';
import i18n from '../locales/i18n';
import classNames from 'classnames';

const { t } = i18n;
export const BR_TAG = '<br />';
export const OPENING_EM_TAG = '<em>';
export const CLOSING_EM_TAG = '</em>';
export const OPENING_ACTIVITY_DETAILS_P0 = `<p><span class="${classNames(
  'desc',
  'color_guide'
)}">`;
export const OPENING_ACTIVITY_DETAILS_P1 = `<p><span class="${classNames(
  'desc'
)}">`;
export const CLOSING_ACTIVITY_DETAILS_P = '</span></p>';
export const OPENING_COLOR_ACCENT = `<span class="${classNames(
  'txt',
  'color_accent',
  'strong_text'
)}">`;
export const OPENING_SPAN = '<span>';
export const CLOSING_SPAN = '</span>';
export const OPENING_ACTIVITY_DETAILS_P2 = `<p><span class="${classNames(
  'desc',
  'color_assort'
)}">`;
export const OPENING_COLOR_POINT = `<span class="${classNames(
  'color_point'
)}">`;
export const OPENING_UNDERLINE = `<span class="${classNames('underline')}">`;

export const activitySummaryInterpolation0 = {
  openingP0: OPENING_ACTIVITY_DETAILS_P0,
  closingP: CLOSING_ACTIVITY_DETAILS_P,
  openingP1: OPENING_ACTIVITY_DETAILS_P1,
  openingColorAccent: OPENING_COLOR_ACCENT,
  closingColorAccent: CLOSING_SPAN,
};
export const activitySummaryInterpolation1 = {
  openingP: OPENING_ACTIVITY_DETAILS_P2,
  closingP: CLOSING_ACTIVITY_DETAILS_P,
  openingColorAccent: OPENING_COLOR_ACCENT,
  closingColorAccent: CLOSING_SPAN,
};
export const colorPointInterpolation = {
  openingColorPoint: OPENING_COLOR_POINT,
  closingColorPoint: CLOSING_SPAN,
};
export const underlineInterpolation = {
  openingUnderline: OPENING_UNDERLINE,
  closingUnderline: CLOSING_SPAN,
};

export const DRAW_LIST_CONTENT_LABELS: Record<string, string> = {
  path: t('drawing'),
  line: t('line'),
  LineWithNonFilledArrow: t('arrow'),
  ellipse: t('ellipse'),
  rect: t('rectangle'),
};

export const SELPUB_URL = 'https://selpub.com/';
export const LANGUAGE = t('language');
export const SELPUB = t('selpub');
export const SERVICE_NAME = 'Selpub Cloud';
export const SERVICE_DESC = t('serviceDescription');
export const SERVICE_INTRODUCTION = t('serviceIntroduction');
export const SELPUB_CLOUD = t('selpubCloud');
export const SELPUB_CREATOR = t('selpubCreator');
export const SELPUB_VIEWER = t('selpubViewer');
export const SERVICE_GUIDE = t('serviceGuide');
export const SERVICE_TERMS = t('termsOfService');
export const SHOW_TERMS = t('termsView');
export const TEACHER = t('teacher');
export const STUDENT = t('student');
export const MANAGE_STUDENT = t('manageStudent');
export const ADD_STUDENT = t('addStudent');
export const STUDENT_BULK_ADD = t('studentBulkAdd');
export const STUDENT_BULK_ADD_DESC = t('studentBulkAddDesc');
export const STUDENT_BULK_ADD_REQUEST = t('studentBulkAddRequest');
export const STUDENT_BULK_ADD_REQUEST_DESC = t('studentBulkAddRequestDesc');
export const REQUEST_ACTION = t('requestAction');
export const REQUEST_TYPE = t('requestType');
export const FORM_DOWNLOAD = t('formDownload');
export const REQUEST_CONTENT_WRITE = t('requestContentWrite');
export const STUDENT_BULK_ADD_ACTION = t('studentBulkAddAction');
export const GROUP_BULK_ADD_ACTION = t('groupBulkAddAction');
export const STUDENT_INFO_EXCEL_FORM = t('studentInfoExcelForm');
export const PRIVACY_CONSENT_FORM = t('privacyConsentForm');
export const EXCEL_UPLOAD_PLACEHOLDER = t('excelUploadPlaceholder');
export const CONSENT_UPLOAD_PLACEHOLDER = t('consentUploadPlaceholder');
export const GROUP_INFO_EXCEL_FORM = t('groupInfoExcelForm');
export const GROUP_BULK_ADD_NOTICE = t('groupBulkAddNotice');
export const GROUP_UPLOAD_PLACEHOLDER = t('groupUploadPlaceholder');
export const FILE_UPLOAD_PLACEHOLDER = t('fileUploadPlaceholder');
export const UPLOAD_NOTICE = t('uploadNotice', {
  openingUnderline: OPENING_UNDERLINE,
  closingUnderline: CLOSING_SPAN,
});
export const TEACHER_DESC = t('isTeacher');
export const STUDENT_DESC = t('isStudent');
export const MINOR_STUDENT_DESC = t('isMinorStudent');
export const LEGAL_REPRESENTATIVE_REQUIRED = t(
  'legalRepresentativeConsentRequired'
);
export const LEGAL_REPRESENTATIVE_APPROVAL = t('legalRepresentativeConsent');
export const LEGAL_REPRESENTATIVE_APPROVAL_DESC = t(
  'legalRepresentativeConsentMessage'
);
export const MOBILE_AUTHENTICATION = t('mobileVerification');
export const MOBILE_NUMBER_DESC = t('enterMobileNumberMessage');
export const COMPLETED_MOBILE_AUTHENTICATION = t('mobileVerificationCompleted');
export const LOGIN = t('login');
export const LOGOUT = t('logout');
export const GUEST_VIEW = t('guestView');
export const MOVE_MAIN = t('goToMain');
export const ID = t('id');
export const ID_SAVE = t('idSave');
export const PASSWORD = t('password');
export const CHANGE_PASSWORD = t('changePassword');
export const PWD = t('passwordLabel');
export const FORGOT_PASSWORD = t('forgotPassword');
export const NEW_PASSWORD = t('newPassword');
export const CONFIRM_NEW_PASSWORD = t('confirmNewPassword');
export const ENTER_PASSWORD = t('enterPassword');
export const PRIVACY = t('privacy');
export const VERIFICATION_CODE = t('verificationCode');
export const EMAIL = t('email');
export const ENTER_EMAIL = t('enterEmail');
export const NICKNAME = t('nickname');
export const NAME = t('name');
export const ENTER_NAME = t('enterName');
export const YEAR_OF_BIRTH = t('birthYear');
export const BIRTHDATE_REQUIRED_MESSAGE = '! ' + t('enterBirthdate');
export const BIRTHDATE_PLACEHOLDER = t('enterBirthdate8Digits');
export const MALE = t('male');
export const FEMALE = t('female');
export const DAD = t('father');
export const MOM = t('mother');
export const REGION = t('region');
export const SCHOOL_GRADE = t('schoolLevel');
export const GRADE = t('schoolGradeLevel');
export const SCHOOL_NAME = t('schoolName');
export const SUBJECT = t('subject');
export const DEPARTMENT = t('department');
export const ACCEPT_ALL_TERMS = t('agreeAllTerms');
export const ENTER = t('input');
export const REENTER = t('reEnter');
export const SAVE = t('save');
export const CHANGE = t('change');
export const FIND = t('find');
export const BROWSE = t('browse');
export const REQUEST = t('request');
export const CONFIRM = t('confirm');
export const PREV = t('previous');
export const NEXT = t('next');
export const SIGNUP = t('signUp');
export const SIGNUP_COMPLETE = t('signUpComplete');
export const REQUIRED_INFO = t('requiredInformation');
export const ADDITIONAL_INFO = t('additionalInformation');
export const OR = t('or');
export const NAVER = t('naver');
export const LOGIN_NAVER = t('startWithNaver');
export const NOT_YET_MEMBER = t('notAMemberYet');
export const ENTER_EMAIL_MESSAGE = t('enterEmailAddress');
export const INVALID_EMAIL = '! ' + t('invalidEmailAddress');
export const PASSWORD_PATTERN = t('passwordRequirements');
export const NOT_SIGNED_EMAIL = '! ' + t('unregisteredEmail');
export const AUTH_SENT = t('verificationCodeSentToEmail');
export const ENTER_VERIFICATION_CODE = t('enterVerificationCode');
export const CHECK_AUTH_AGAIN = '! ' + t('verificationCodeRetry');
export const VERIFICATION_MSG = t('verificationCodeConfirmed');
export const PWD_VALIDATION_MSG = '! ' + t('passwordValidationMessage');
export const MATCH_PWD = t('passwordMatch');
export const NOT_MATCH_PWD = '! ' + t('passwordNotMatch');
export const ENTER_NICKNAME = '! ' + t('enterNickname');
export const ENTER_MORE_LETTERS = '! ' + t('enterMoreLetters');
export const PROFANITY_WARNING_MESSAGE = '! ' + t('profanityWarningMessage');
export const CHECK_BIRTH_YEAR = '! ' + t('retryBirthdate');
export const SIGN_UP_OVER_14 = '! ' + t('signupAsStudent');
export const SIGN_UP_UNDER_14 = '! ' + t('signupAsMinorStudent');
export const SELECT_GENDER = '! ' + t('selectGender');
export const SELECT_PARENT = '! ' + t('selectParent');
export const ENTER_REGION = '! ' + t('selectRegion');
export const ENTER_SCHOOL_TYPE = '! ' + t('selectSchoolLevel');
export const ENTER_SCHOOL_NAME = '! ' + t('selectSchoolName');
export const ENTER_GRADE_TYPE = '! ' + t('selectSchoolGradeLevel');
export const ENTER_DEPARTMENT_TYPE = '! ' + t('selectDepartment');
export const SUCCESS_CHANGED_PWD = t('passwordSuccessfullyChanged');
export const SUCCESS_SIGNUP = t('signupCompleted');
export const WELCOME = t('welcome');
export const INACTIVE_EXPLANATION = t('inactiveMessage', {
  br: BR_TAG,
  openingEm: OPENING_EM_TAG,
  closingEm: CLOSING_EM_TAG,
});
export const LAST_LOGIN_DATE = t('lastLoginDate');
export const INACTIVE_DATE = t('inactiveDate');
export const DELETE_DUE_DATE = t('resourcesScheduledDeletionDate');
export const DELETE_CONDITIONS = t('inactiveResourcesDeletionMessage', {
  openingEmUnderline: `<em class=${classNames('underline')}>`,
  closingEm: CLOSING_EM_TAG,
  br: BR_TAG,
});
export const DELETE_DESC = ' ' + t('clickToDeactivateDormant');
export const SENT_VERIFICATION_CODE = t('codeSentToEmail');
export const RE_REQUEST = t('requestAgain');
export const VERIFICATION_HELP = t('verificationFailedMessage', { br: BR_TAG });
export const RECOVER_ACCOUNT = t('reactivateAccount');
export const RECOVER_ACCOUNT_COMPLETE = t('accountReactivated');
export const CONTACT_US = t('contactUs');
export const CUSTOMIZED_SERVICE = t('customizedService');
export const SERVICE_RESTRICTIONS = t('serviceRestrictionMessage', {
  openingEm: OPENING_EM_TAG,
  closingEm: CLOSING_EM_TAG,
  br: BR_TAG,
});
export const REASON = t('reason');
export const TERM = t('period');
export const CONTACT_US_DESC = t('clickContactUs', { br: BR_TAG });
export const REPLY_TO_EMAIL = t('replyToEmail');
export const EPUB = 'EPUB';
export const PDF = 'PDF';

// Navigation
export const LIBRARY = t('myLibrary');
export const SHARED_LIBRARY = t('sharedLibrary');
export const DRIVE = t('myStorage');
export const SEARCH = t('search');
export const SHARING_LIBRARY = t('sharingLibrary');
export const TRASH = t('trash');
export const CLASSROOM = t('class');
export const SETTINGS = t('management');
export const MOVE_TO_HOME = t('moveToHome');
export const MOVE_TO_STORAGE = t('moveToStorage');
export const USER_GUIDE = t('userGuide');
export const USER_GUIDE_URL =
  'https://www.youtube.com/playlist?list=PL3aVihMZfqI-hSWiMvKwvn-v9WnCiLSyN';
export const NAVIGATION_MENU_MAP: StringByKey = {
  library: LIBRARY,
  share: SHARED_LIBRARY,
  search: SHARING_LIBRARY,
  mydrive: DRIVE,
  trash: TRASH,
  classroom: CLASSROOM,
  settings: SETTINGS,
} as const;

// Container
export const SETUP = t('settings');
export const MAIN = t('main');
export const NOTIFICATION = t('notification');
export const ACCOUNT = t('myAccount');
export const INACTIVE_ACCOUNT_INFO = t('inactiveAccountNotice');
export const ACCOUNT_INACTIVE_MESSAGE = t('inactiveAccountMessage');
export const SERVICE_RESTRICTION_INFO = t('usageRestrictionGuide');
export const SERVICE_RESTRICTION_CONTACT = t('inquiryUsageRestriction');
export const CONTACT_COMPLETE = t('inquiryCompleted');
export const UPLOAD = t('upload');
export const MY_DATA_REGISTRATION = t('registerMyResources');
export const SEARCH_DATA = t('findResources');
export const UPLOADING = t('uploading');
export const SHARING = t('sharing');
export const SHARING_ENDED = t('shareEnd');
export const SHARED_EBOOK = t('registeredEbooks');
export const LIST = t('list');
export const FOLDER = t('folder');
export const CREATE_FOLDER = t('createFolder');
export const EBOOK_OPEN = t('openEbook');
export const EBOOK_EDIT = t('editEbook');
export const EBOOK_SHARE = t('shareEbook');
export const WEB_DATA = t('webResources');
export const FILE_DATA = t('fileResources');
export const DETAILS = t('detailInformation');
export const DETAILS_CLOSE = t('closeDetailInformation');
export const OPEN = t('open');
export const COLLAPSE = t('collapse');
export const DOWNLOAD = t('download');
export const RESTORE = t('restore');
export const SORT = t('sort');
export const EDIT = t('edit');
export const VIEW = t('view');
export const COPY = t('copy');
export const COMPLETE = t('complete');
export const PROGRESS = t('progress');
export const REGISTRATION = t('register');
export const APPROVAL = t('approval');
export const REQUESTING = t('requesting');
export const CANCELLATION = t('cancellation');
export const DELETE = t('delete');
export const DELETE_ALL = t('deleteAll');
export const DELETE_PERMANENTLY = t('permanentDelete');
export const DELETION_SCHEDULED_FILES = t('filesToBeDeleted');
export const EDIT_TRASH = t('editTrash');
export const EMPTY_TRASH = t('emptyTrash');
export const ADD = t('add');
export const ADD_ACTION = t('addAction');
export const INDENT = t('indent');
export const CONTENT = t('content');
export const EMPTY_CONTENT = t('noContent');
export const ENTER_PLACEHOLDER = t('enterPlaceholder');
export const ENTER_PUBLISHER = t('enterPublisher');
export const ENTER_AUTHOR = t('enterAuthor');
export const SELECT_ALL = t('selectAll');
export const SELECT = t('select');
export const MORE = t('seeMore');
export const ANSWER_COMPLETE = t('answerCompleted');
export const ANSWER_YET = t('answerInProgress');
const BOOK_INFO_DESCRIPTION = t('bookInformationDescription', { br: BR_TAG });
const FILE_INFO_DESCRIPTION = t('fileInformationDescription', { br: BR_TAG });
export const DETAILS_DESCRIPTION: StringByKey = {
  library: BOOK_INFO_DESCRIPTION,
  share: BOOK_INFO_DESCRIPTION,
  mydrive: FILE_INFO_DESCRIPTION,
  search: BOOK_INFO_DESCRIPTION,
  trash: BOOK_INFO_DESCRIPTION,
  classroom: BOOK_INFO_DESCRIPTION,
  settings: BOOK_INFO_DESCRIPTION,
} as const;
export const NO_PUBLIC_EBOOKS = t('noPublicEbook');
export const EMPTY_TRASH_MESSAGE = t('trashIsEmpty');
export const DELETE_AFTER_30_DAYS = t('permanentDeletionNotice');
export const TOTAL = t('totalN');
export const CATEGORY = t('type');
export const SIZE = t('capacity');
export const USED_SIZE = t('usageAmount');
export const EXCEEDED = t('exceed');
export const ASCENDING = t('ascending');
export const DESCENDING = t('descending');
export const UPLOADED_DATE = t('uploadDate');
export const OPENED_DATE = t('openDate');
export const SHARED_DATE = t('shareDate');
export const SHARED_REG_DATE = t('shareDateRegistered');
export const SHARED_PERIOD = t('sharePeriod');
export const NO_LIMITATION = t('noLimit');
export const DELETED_DATE = t('deleteDate');
export const MODIFIED_DATE = t('modificationDate');
export const CREATION_DATE = t('creationDate');
export const TITLE_NAME = t('titleName');
export const FILE_NAME = t('fileName');
export const LOCATION = t('location');
export const FILE_SIZE = t('size');
export const HITS = t('viewCount');
export const OWNER = t('owner');
export const OPTION = t('option');
export const EBOOK_LIST_EDIT = t('editLibrary');
export const ORIGINAL = t('original');
export const NEW = t('new');
export const NEW_ENG = 'New';
export const COVER = t('cover');
export const BOOK = t('book');
export const EBOOK_COVER = t('bookCover');
export const DEFAULT_COVER_IMAGE = t('coverImagePng');
export const EBOOK_INFO = t('bookInformation');
export const INDEX = t('tableOfContents');
export const ONE_LINE_MEMO = t('oneLineMemo');
export const NO_MEMO = t('noMemo');
export const FILE = t('file');
export const FILE_INFO = t('fileInformation');
export const FILE_INFO_GUIDE: StringByKey = {
  library: `${t('fileTypeDescription')}
  ${t('fileCapacityDescription')}
  ${t('librarySelpubUsageAmount', {
    br: BR_TAG,
  })}`,
  share: `${t('fileTypeDescription')}
  ${t('fileCapacityDescription')}
  ${t('selpubUsageAmount')}`,
  mydrive: `${t('fileTypeDescription')}
  ${t('selpubUsageAmount')}`,
  search: `${t('fileTypeDescription')}
  ${t('selpubUsageAmount')}`,
  trash: `${t('fileTypeDescription')}
  ${t('selpubUsageAmount')}`,
};
export const FILE_UPLOAD = t('fileUpload');
export const FILE_SHARE = t('fileShare');
export const SHARE_INFO = t('sharedInformation');
export const FILE_RELEASE = t('filePublic');
export const PUBLIC_INFO = t('publicInformation');
export const PUBLIC_DATE = t('publicDate');
export const HISTORY = t('activity');
export const URL_INFO = 'URL ' + t('information');
export const FOLDER_INFO = t('folderInformation');
export const FOLDER_NAME = t('folderName');
export const USE_INFO = t('usageInformation');
export const SHARED_LINK = t('shareLink');
export const SHARED_USER = t('userShare');
export const SHARING_STOP = t('stopSharing');
export const TITLE = t('title');
export const PUBLICATION_DATE = t('publicationDate');
export const PUBLISHER = t('publisher');
export const AUTHOR = t('author');
export const START_PAGE = t('startPage');
export const PAGE_NUMBER = t('pageNumber');
export const NUMBER_ABBR = 'No.';
export const DATE = t('date');
export const TIME = t('time');
export const PAGE = t('page');
export const PUBLIC = t('public');
export const PRIVATE = t('private');
export const KEYWORD = t('keyword');
export const PREFERENCES = t('defaultSettings');
export const INFORMATION = t('information');
export const ACCOUNT_INFO = t('myInformation');
export const STORAGE = t('storageSpace');
export const SELPUB_CLOUD_USAGE = t('selpubCloudUsage');
export const FULL_STORAGE = t('totalStorage');
export const PURCHASE = t('purchase');
export const SHARED_LINK_NOTIFICATION = t('shareLinkNotification');
export const STUDENT_REGISTRATION_REQUEST = t('studentRegistrationRequest');
export const SERVICE_INFO = t('serviceAnnouncement');
export const NOTICE = t('notice');
export const FAQ = t('frequentlyAskedQuestions');
export const FEEDBACK = t('sendFeedback');
export const FEEDBACK_TYPE = t('feedbackType');
export const WRITING_FEEDBACK = t('writeFeedback');
export const CHARACTER_COUNT = t('characterCount');
export const RECEIVE_EMAIL_REPLIES = t('receiveRepliesViaEmail');
export const SEND = t('send');
export const TERMS = t('terms');
export const PRIVACY_POLICY = t('privacyPolicy');
export const PUSH_AGREEMENT = t('consentToReceiveNotifications');
export const MEMBER = t('member');
export const WITHDRAWAL = t('withdrawal');
export const WITHDRAWAL_REASON = t('withdrawalReason');
export const ETC = t('misc');
export const IDENTIFICATION = t('identityVerification');
export const SEPARATOR = t('delimiter');
export const LEARNING_ACTIVITY = t('learningActivity');
export const MY_ACTIVITY_INFO = t('myActivityInformation');
export const CLASS_ACTIVITY_INFO = t('classActivityInformation');
export const STUDENT_ACTIVITY_INFO = t('studentActivityInformation');
export const EBOOK_ACTIVITY_INFO = t('ebookActivityInformation');
export const CLASS_MANAGEMENT = t('classManagement');
export const CLASS_INFORMATION = t('classInformation');
export const TEACHER_INFORMATION = t('teacherInformation');
export const GROUP = t('group');
export const MANAGE_GROUP = t('manageGroup');
export const ADD_GROUP = t('addGroup');
export const GROUP_NAME = t('groupName');
export const STUDENT_NUMBER = t('numberOfStudents');
export const DETAIL = t('details');
export const CLASS_CAPACITY_EXCEEDED_MESSAGE = t(
  'classManagementStatusChanged',
  { br: BR_TAG }
);
export const INCREASE_CLASS_CAPACITY = t('increaseManagedPeople');
export const MAX_ADDITIONAL_STUDENTS = t('additionalStudents');
export const MAX_ADDITIONAL_STUDENTS_EXCEEDED = t('exceededAdditionalStudents');
export const HONORIFIC_SUFFIX = t('userName');
export const VOLUME = t('bookCount');
export const MIN = t('minimum');
export const MAX = t('maximum');

export const LEARNING_ACTIVITY_SUFFIX = t('userLearningActivity', {
  openingSpan: `<span class="${classNames('nickname')}">`,
  closingSpan: '</span>',
});
export const CLASS_ACTIVITY_SUFFIX = t('userClassActivityManagement', {
  openingSpan: `<span class="${classNames('nickname')}">`,
  closingSpan: '</span>',
});
export const STUDENT_ACTIVITY_SUFFIX = t('studentLearningActivity', {
  openingSpan: `<span class="${classNames('nickname')}">`,
  closingSpan: '</span>',
});
export const STUDENT_EBOOK_ACTIVITY_SUFFIX = t('studentEbookActivity', {
  openingSpan: `<span class="${classNames('nickname')}">`,
  closingSpan: '</span>',
});
export const EBOOK_ACTIVITY_SUFFIX = t('ebookLearningActivity', {
  openingSpan: `<span class="${classNames('nickname')}">`,
  closingSpan: '</span>',
});
export const STUDENT_MAIN_DASHBOARD_TITLE = t('studentMainDashboardTitle', {
  openingSpan: `<span class="${classNames('nickname')}">`,
  closingSpan: '</span>',
});
export const TEACHER_MAIN_DASHBOARD_TITLE = t('teacherMainDashboardTitle', {
  openingSpan: `<span class="${classNames('nickname')}">`,
  closingSpan: '</span>',
});
export const COLLECTED_INFO_MESSAGE = t('collectedDateRange');
export const COLLECTING_INFORMATION = t('collectingInformation');
export const DELETE_ALL_ACTIVITY = t('deleteAllActivityRecords');
export const TOTAL_STUDY_TIME = t('totalLearningTime');
export const PRIMARY_STUDY_HOURS = t('learningTimeSlot');
export const PRIMARY_STUDY_DAYS = t('weeklyLearningDay');
export const STUDY_DAYS = t('learningDay');
export const DAILY_STUDY_COUNT = t('dailyBooksLearned');
export const MAX_CONCENTRATION_TIME = t('maximumConcentrationTime');
export const NOTE_USAGE_TIME = t('noteUsageTime');
export const ACTIVITY_TITLE: StringByKey = {
  total: TOTAL_STUDY_TIME,
  timeZone: PRIMARY_STUDY_HOURS,
  weekZone: PRIMARY_STUDY_DAYS,
  daily: DAILY_STUDY_COUNT,
  attention: MAX_CONCENTRATION_TIME,
  note: NOTE_USAGE_TIME,
} as const;
export const SHOW_DETAILS = t('viewDetails');
export const TOTAL_LEARNING_TIME_DETAILS = t('totalLearningTimeDetails', {
  openingSpan: `<span class="${classNames('strong_text')}">`,
  closingSpan: '</span>',
});
export const CLASS_AVERAGE_LEARNING_TIME = t('classAverageLearningTime', {
  openingSpan: `<span class="${classNames('strong_text')}">`,
  closingSpan: '</span>',
});
export const CLASS_TOTAL_LEARNING_TIME_DETAILS = t(
  'classTotalLearningTimeDetails',
  activitySummaryInterpolation0
);
export const CLASS_DAILY_AVG_BOOKS_LEARNED = t('classDailyAverageBooksLearned');
export const MIN_MAX_BOOKS_LEARNED_DETAILS = t('minMaxBooksLearnedDetails');
export const DAILY_BOOKS_LEARNED_DETAILS = t(
  'dailyBooksLearnedDetails',
  activitySummaryInterpolation0
);
export const CLASS_MAX_CONCENTRATION_TIME_DETAILS = t(
  'classMaxConcentrationTimeDetails',
  activitySummaryInterpolation0
);
export const MAX_CONCENTRATION_TIME_DETAILS = t(
  'maxConcentrationTimeDetails',
  activitySummaryInterpolation0
);
export const NOTE_USAGE_TIME_DETAILS = t(
  'noteUsageTimeDetails',
  activitySummaryInterpolation0
);
export const SELPUB_STUDENTS_DAILY_BOOKS_LEARNED = t(
  'selpubStudentsDailyBooksLearned',
  activitySummaryInterpolation1
);
export const SELPUB_STUDENTS_AVERAGE_CONCENTRATION_TIME = t(
  'selpubStudentsAverageConcentrationTime',
  activitySummaryInterpolation1
);
export const SELPUB_STUDENTS_AVERAGE_NOTE = t(
  'selpubStudentsAverageNoteUsage',
  activitySummaryInterpolation1
);
export const CLASS_NOTE_USAGE_TIME_DETAILS = t('classNoteUsageTimeDetails');
export const CLASS_NOTE_USAGE_AVERAGE_DETAILS = t(
  'classNoteUsageAverageDetails',
  activitySummaryInterpolation1
);
export const PEAK_LEARNING_HOURS = t('peakLearningPeriod ');
export const MOST_LEARNED_DAY = t('mostLearnedOnDayOfWeek', {
  openingColorAccent: OPENING_COLOR_ACCENT,
  closingColorAccent: CLOSING_SPAN,
  br: BR_TAG,
});
export const COLLECTED_STUDENT_AVERAGE_INFO = t('classCollectedDateRange');
export const USER_LOGIN_ANALYSIS = t('loginBasedInformation');
export const CASES = t('itemCount');
export const SHARED_EBOOK_BY_ME = t('ebooksSharedByMe');
export const ACTIVITY_LIBRARIES = {
  library: LIBRARY,
  share: SHARED_LIBRARY,
  sharedByMe: SHARED_EBOOK_BY_ME,
} as const;
export const SEARCH_INPUT_PLACEHOLDER = t('enterSearchWord');
export const ARROW = t('arrow');
export const EMPTY_EBOOK_LIST = t('noRegisteredEbooks');
export const EMPTY_STUDENT_LIST = t('noRegisteredStudent');
export const SEARCH_RESULT_NOT_FOUND = t('noSearchResults');
export const LAST_LEARNING_DATE = t('lastLearningDate');
export const LAST_ATTENDANCE = t('lastAttendance');
export const LAST_ATTENDANCE_EXCLUDING_TODAY = t(
  'lastAttendanceExcludingToday'
);
export const LAST_ATTENDANCE_DATE = t('lastAttendanceDate');
export const LAST_ATTENDANCE_LOGOUT_NOTICE = t('lastAttendanceLogoutNotice');
export const ATTENDED_ON = t('attendedOn', { br: BR_TAG });
export const ATTENDED_ON_MOBILE = t('attendedOn', { br: BR_TAG });
export const ATTENDED_ON_DESKTOP = t('attendedOn', { br: '' });
export const STUDENTS_ATTENDED = t('studentsAttended');
export const NO_STUDENTS_ATTENDED = t('noStudentsAttended');
export const LAST_STUDY = t('lastStudy');
export const AI_SUMMARY_DISCLAIMER = t('aiSummaryDisclaimer');
export const SUMMARIZING_PAGE = t('summarizingPage');
export const SUMMARIZING_PAGE_ERROR = t('summarizingPageError');
export const EXTRACTING_KEYWORD = t('extractingKeyword');
export const EXTRACTING_KEYWORD_ERROR = t('extractingKeywordError');
export const PLEASE_RETRY_LATER = t('pleaseRetryLater');
export const NO_RECENT_LEARNING_PAGE = t('noRecentLearningPage');
export const LEARNING_TIME = t('learningTime');
export const LEARNING_TOOL_ACTIVITY = t('learningToolActivity');
export const KEYWORD_RANKING_DESCRIPTION = t('keywordRankingDescription');
export const KEYWORD_RANKING_STUDENT_DESCRIPTION = t(
  'keywordRankingStudentDescription'
);
export const KEYWORD_AI_DISCLAIMER = t('keywordAiDisclaimer');
export const RECENT_LEARNING_AI_DISCLAIMER = t('recentLearningAiDisclaimer');
export const STUDENTS_COUNT = t('studentsCount');
export const LEARNING_TOOLS = t('learningTools');
export const LEARNING_CONTENTS = t('learningContents');
export const DAILY_LEARNING_BOOKS = t('dailyLearningBooks');
export const LEARNING_KEYWORD = t('learningKeyword');
export const RECENT_LEARNING_PAGE_KEYWORD = t('recentLearningPageKeyword');
export const RECENT_LEARNING_PAGE_SUMMARY = t('recentLearningPageSummary');
export const CONTENT_LEARNING = t('contentLearning');
export const QUIZ_LEARNING = t('quizLearning');
export const ALL = t('all');
export const CLASSTALK = t('classTalk');
export const BOOKMARK = t('bookmark');
export const HIGHLIGHTER = t('highlighter');
export const MEMO = t('memo');
export const TEXT_COPY = t('copyText');
export const TEXT_SEARCH = t('textSearch');
export const RECENT_SEARCH_TERMS = t('recentSearches');
export const READING_ASSISTANT = t('readAloud');
export const ZOOM = t('zoomInOut');
export const DRAWING = t('drawing');
export const STICKER = t('sticker');
export const DRAWING_RECORD = t('drawingRecording');
export const LINK = t('link');
export const PRINT = t('print');
export const NOTE = t('note');
export const ICON = t('icon');
export const VIDEO = t('video');
export const AUDIO = t('voice');
export const IMAGE = t('image');
export const MOVE_PAGE = t('pageNavigation');
export const MEDIA = t('media');
export const CONTENTS = t('contents');
export const POPUP = t('popup');
export const PHOTO_SLIDE = t('photoSlide');
export const TOAST_POPUP = t('toastPopup');
export const OVERLAY_BOX = t('hideBox');
export const MULTIPLE_CHOICE = t('multipleChoice');
export const SUBJECTIVE = t('subjective');
export const LINE_DRAWING = t('lineDrawing');
export const OX_QUIZ = t('oxQuiz');
export const FORMULA_RECOGNITION = t('formulaRecognition');
export const SPEAKING_PRACTICE = t('speakingPractice');
export const LEARNING_WITH_SELPUB_VIEWER = t('learningWithSelpubViewer');
export const LEARNING_TOOL_TEXT = t('learningTool');
export const LEARNING_CONTENT_TEXT = t('learningContent');
export const MOST_USED = t('mostUsed');
export const LEARNING_TOOL_LABELS: StringByKey = {
  Bookmark: BOOKMARK,
  Drawing: DRAWING,
  Sticker: STICKER,
  Highlighter: HIGHLIGHTER,
  Link: LINK,
  Memo: MEMO,
  'Copy Text': TEXT_COPY,
  'Text Search': TEXT_SEARCH,
  'Read Aloud': READING_ASSISTANT,
  'Table of Contents': INDEX,
  'Zoom In/Out': ZOOM,
  'Record Drawing': DRAWING_RECORD,
  Print: PRINT,
  Note: NOTE,
} as const;
export const LEARNING_TOOLS_ACTIVITIES: StringByKey = {
  bookMarkCount: BOOKMARK,
  highlighterCount: HIGHLIGHTER,
  memoCount: MEMO,
  copyCount: TEXT_COPY,
  searchCount: TEXT_SEARCH,
  readCount: READING_ASSISTANT,
  indexCount: INDEX,
  zoomingCount: ZOOM,
  drawCount: DRAWING,
  stickerCount: STICKER,
  drawVideoCount: DRAWING_RECORD,
  linkCount: LINK,
  printCount: PRINT,
  noteCount: NOTE,
} as const;
export const CONTENT_LABELS: StringByKey = {
  'Icon(Video)': `${ICON}(${VIDEO})`,
  'Icon(Voice)': `${ICON}(${AUDIO})`,
  'Icon(Image)': `${ICON}(${IMAGE})`,
  'Icon(File)': `${ICON}(${FILE})`,
  'Icon(Web)': `${ICON}(Web)`,
  'Icon(Icon(Move to Page))': `${ICON}(${MOVE_PAGE})`,
  'Media(Image)': `${MEDIA}(${IMAGE})`,
  'Media(Video)': `${MEDIA}(${VIDEO})`,
  'Media(Voice)': `${MEDIA}(${AUDIO})`,
  'Content(Drawing)': `${CONTENTS}(${DRAWING})`,
  'Content(Photo Slide)': `${CONTENTS}(${PHOTO_SLIDE})`,
  'Popup(Toast Popup)': `${POPUP}(${TOAST_POPUP})`,
  'Masking Box': OVERLAY_BOX,
  'Multiple Choice': MULTIPLE_CHOICE,
  Subjective: SUBJECTIVE,
  'Line Drawing': LINE_DRAWING,
  'OX Quiz': OX_QUIZ,
  'Formula Recognition': FORMULA_RECOGNITION,
  'Speaking Practice': SPEAKING_PRACTICE,
} as const;
export const CONTENTS_LEARNING_ACTIVITIES: StringByKey = {
  classtalkCount: CLASSTALK,
  iconVideoCount: `${ICON}(${VIDEO})`,
  iconVoiceCount: `${ICON}(${AUDIO})`,
  iconImageCount: `${ICON}(${IMAGE})`,
  iconFileCount: `${ICON}(${FILE})`,
  iconWebCount: `${ICON}(Web)`,
  iconPageMoveCount: `${ICON}(${MOVE_PAGE})`,
  mediaImageCount: `${MEDIA}(${IMAGE})`,
  mediaVideoCount: `${MEDIA}(${VIDEO})`,
  mediaVoiceCount: `${MEDIA}(${AUDIO})`,
  drawCount: `${CONTENTS}(${DRAWING})`,
  slideCount: `${CONTENTS}(${PHOTO_SLIDE})`,
  toastCount: `${POPUP}(${TOAST_POPUP})`,
  boxCount: OVERLAY_BOX,
} as const;
export const EBOOK_ACTIVITY_DELETE = t('deleteEbookActivityRecord');
export const FILTER = t('filter');
export const CLASS_STUDENT_ACTIVITIES: StringByKey = {
  nm: NAME,
  schoolNm: SCHOOL_NAME,
  gradeNm: GRADE,
  groupNames: GROUP,
  totalTime: TOTAL_STUDY_TIME,
  lastDate: LAST_LOGIN_DATE,
  dailyProject: DAILY_STUDY_COUNT,
  attentionTime: MAX_CONCENTRATION_TIME,
  noteTime: NOTE_USAGE_TIME,
};
export const PROJECT_STUDENT_ACTIVITIES: StringByKey = {
  nm: NAME,
  schoolNm: SCHOOL_NAME,
  gradeNm: GRADE,
  groupNames: GROUP,
  totalTime: TOTAL_STUDY_TIME,
  lastDate: LAST_LOGIN_DATE,
};
export const ALL_SCHOOL_GRADES = t('allSchoolLevels');
export const ALL_GRADE_CLASSES = t('allGrades');
export const BACK = t('goBack');
export const STUDENT_MANAGEMENT_INFO = t('managementInfo');
export const STUDENT_INFO = t('studentInformation');
export const USER_STATUS = t('memberStatus');
export const DELETE_ACCOUNT = t('deleteAccount');
export const EMAIL_INFO = t('emailInformation');
export const SHOW_DETAILS_MESSAGE = t('itemDetailsOnClick');
export const TOTAL_CORRECT_RATE_DESC = t('correctAnswerRateDescription', {
  br: BR_TAG,
});
export const TOTAL_CORRECT_RATE = t('overallCorrectAnswerRate');
export const DIFFICULTY = t('difficulty');
export const LEVEL = t('level');
export const ANSWER = t('answerSheet');
export const CORRECT_ANSWER = t('correctAnswer');
export const CORRECT_ANSWER_RATE = t('correctAnswerRate');
export const GRADING = t('scoring');
export const TOPIC = t('topic');
export const QUIZ_TABLE_HEAD_LIST: StringByKey = {
  page: PAGE,
  dispContentType: CATEGORY,
  rank: DIFFICULTY,
  dispLevelType: LEVEL,
  userAnswer: ANSWER,
  answer: CORRECT_ANSWER,
  correctRate: CORRECT_ANSWER_RATE,
  dispGrade: GRADING,
} as const;
export const QUIZ_INFORMATION_DETAILS: StringByKey = {
  page: PAGE,
  dispContentType: CATEGORY,
  rank: DIFFICULTY,
  dispLevelType: LEVEL,
  correctRate: CORRECT_ANSWER_RATE,
  answer: CORRECT_ANSWER,
  indexContent: INDEX,
  topic: TOPIC,
} as const;
export const SOLUTION_INFORMATION_DETAILS: StringByKey = {
  dispGrade: GRADING,
  userAnswer: ANSWER,
} as const;
export const REGISTER_QUIZ_FOR_COLLECTION = t('registerQuizForCollection');

export const SUBSCRIPTION_SERVICE_GUIDE = t('subscriptionServiceInfo');
export const SUBSCRIPTION_SERVICE_NAME: StringByKey = {
  basic: t('basic'),
  pro: t('pro'),
  enterprise: t('enterprise'),
} as const;
export const MONTHS = t('months');
export const CURRENCY_UNIT = t('currencyUnit');
export const DEFAULT_SELPUB_FEATURE = t('basicSelpubFeatures');
export const LEARNING_CONTENTS_EDITOR = t('learningContentEditTool');
export const LEARNING_CONTENTS_VIEWER = t('learningContentViewer');
export const CLASS_MANAGEMENT_CUSTOMIZE = t('customClassManagementProvision');
export const STUDENT_ACCOUNT_PER_TEACHER = t('studentAccountPerTeacher', {
  openingSpan: OPENING_SPAN,
  closingSpan: CLOSING_SPAN,
});
export const TEACHER_DASHBOARD = t('teacherDashboard');
export const STUDENT_DASHBOARD = t('studentDashboard');
export const AI_LEARNING_TOOL = t('aiLearningTool');
export const CHOOSE_ONE = t('selectN');
+'1';
export const CHOICE = t('selectN');
export const UNLIMITED = t('unlimited');
export const CUSTOMIZING = t('customizing');
export const AI_LEARNING_TOOLS_DESCRIPTION = t('aiToolsFeatures');
export const SELPUB_SLIDE_FEATURE = t('selpubSlideFeature');
export const STORAGE_TEXT = t('storage');
export const MULTIMEDIA_UPLOAD_STORAGE_LIMIT = t('multimediaUploadLimit');
export const CLASS_MANAGEMENT_PERSONNEL_ADDITION = t('addClassManagedPeople');
export const CLASS_MANAGEMENT_ADDITIONAL_PERSONNEL = t(
  'classManagementAdditionalPeople'
);
export const MINIMUM_BASIC_MEMBERSHIP_REQUIREMENT = t(
  'additionalConditionMembership'
);
export const ONE_MONTH = '1' + t('months');
export const MONTHLY = t('monthly');
export const ANNUAL = t('annual');
export const PER_PERSON = t('perPerson');
export const ENTERPRISE_CONTACT = t('enterpriseInquiry');
export const MEMBERSHIP_PAYMENT = t('membershipPayment');
export const MEMBERSHIP = t('membership');
export const SUBSCRIPTION_PERIOD = t('usagePeriod');
export const NEXT_PAYMENT_DATE = t('nextPaymentDate');
export const CLASS_MANAGEMENT_PERSONNEL = t('classManagementPersonnel');
export const NUMBER_OF_PEOPLE = t('numberOfPeople');
export const HEADCOUNT = t('people');
export const TTS_DESC = t('textToSpeech');
export const PRONUNCIATION_EVALUATION_DESC = t(
  'pronunciationEvaluationDescription'
);
export const FORMULA_DESC = t('formulaRecognitionDescription');
export const ADDITION = t('addition');
export const SUBTRACTION = t('subtraction');
export const TODAY_PAYMENT = t('todayPaymentAmount');
export const EVERY_MONTH = t('everyMonth');
export const EVERY_YEAR = t('everyYear');
export const CARD_NUMBER = t('cardNumber');
export const CARD_EXPIRATION_DATE = t('cardExpirationDate');
export const BIRTHDATE = t('birthDate');
export const CARD_BUSINESS_REGISTRATION_NUMBER = t('businessNumber10Digits');
export const MONTHLY_INSTALLMENTS = t('installmentMonths');
export const MOBILE_NUMBER = t('mobilePhoneNumber');
export const AUTOMATIC_PAYMENT_DESC = t('automaticPaymentCancellationDesc');
export const MORE_DETAILS_SERVICE_REFERENCE =
  '※ ' +
  t('referServiceGuide', {
    openingLink: `<a href="${SELPUB_URL}pricing" target="_blank" class=${classNames(
      'link_t'
    )}>`,
    closingLink: '</a>',
  });
export const REFUND_INFORMATION = t('refundInformation');
export const PAYMENT = t('payment');
export const MONTH = t('month');
export const YEAR = t('year');
export const YEARS = t('NYear');
export const BIRTHDATE_SIX_DIGITS_PLACEHOLDER = t('enterBirthdate6Digits');
export const CARD_PIN_PREFIX = t('firstTwoDigits');
export const PAY_IN_FULL = t('lumpSumPayment');
export const ENTER_MOBILE_NUMBER = t('enterWithoutHyphen');
export const MEMBERSHIP_INFO = t('membershipInformation');
export const PAYMENT_INFO = t('paymentInfo');
export const CURRENT_MEMBERSHIP = t('currentMembership');
export const CHANGE_MEMBERSHIP = t('changeMembership');
export const ADDITIONAL_MANAGEMENT_PERSONNEL = t(
  'additionalManagementPersonnel'
);
export const ADD_MANAGEMENT_PERSONNEL = t('addManagementPersonnel');
export const MEMBERSHIP_CHANGE_SCHEDULE_NOTICE =
  '※ ' + t('membershipChangeNotice');
export const CANCEL_CHANGE = t('cancelChange');
export const CANCEL_MEMBERSHIP = t('cancelMembership');
export const CREDIT_CARD = t('creditCard');
export const CHANGE_CARD = t('cardChange');
export const PAYMENT_HISTORY = t('paymentHistory');
export const SCHEDULED_PAYMENT_AMOUNT = t('upcomingPaymentAmount');
export const RECURRING_BILLING = t('regularBilling');
export const DIFFERENCE_BILLING = t('differenceCharge');
export const ADD_PERSONNEL = t('addPersonnel');
export const CURRENT_MEMBERSHIP_AMOUNT = t('currentMembershipFee');
export const ADDITIONAL_PERSONNEL_AMOUNT = t(
  'additionalManagementPersonnelAmount'
);
export const SCHEDULED_PAYMENT_AMOUNT_DESC =
  '※ ' + t('upcomingPaymentDescription');
export const DIFFERENCE_BILLING_DESC = '※ ' + t('differenceChargeDescription');
export const ADDITIONAL_BILLING_DESC = '※ ' + t('membershipChangeDiffDesc');
export const CANCEL_REASON = t('cancellationReason');
export const INPUT_100_CHARS = t('directInput100Char');
export const CANCEL_MEMBERSHIP_DATE_DESC =
  '※ ' + t('cancelMembershipDateDesc', colorPointInterpolation);
export const FILE_DELETION_DESC =
  '※ ' + t('fileDeletionDesc', colorPointInterpolation);
export const STUDENT_STATUS_CHANGE_DESC =
  '※ ' +
  t('studentStatusChangeDesc', { ...colorPointInterpolation, br: BR_TAG });
export const FILE_AUTO_DELETION_DESC = t(
  'filesAutoDeletionDesc',
  underlineInterpolation
);
export const MEMBERSHIP_CANCEL_COMPLETE = t('membershipCancelled');
export const MEMBERSHIP_RESTART = t('restartMembership');
export const MEMBERSHIP_CANCEL_COMPLETE_DESC = t(
  'membershipBenefitsPeriodDesc'
);
export const PAYMENT_HISTORY_DESC = t('paymentHistoryYear');
export const PAYMENT_DATE = t('paymentDate');
export const PAYMENT_AMOUNT = t('paymentAmount');
export const SCHEDULED = t('scheduled');
export const RECEIPT = t('receipt');
export const MEMBERSHIP_AMOUNT = t('membershipAmount');
export const MEMBERSHIP_CHANGE_DIFFERENCE = t('membershipChangeDifference');
export const ADDITIONAL_PERSONNEL_CHANGE_DIFFERENCE = t(
  'additionalManagedPeopleChangeAmount'
);
export const PAYMENT_METHOD = t('paymentMethod');
export const PAYMENT_COMPLETE_MESSAGE = t('paymentCompleteMessage', {
  br: BR_TAG,
});
export const PAYMENT_FAILED_MESSAGE = t('paymentFailedMessage', { br: BR_TAG });
export const MEMBERSHIP_CHANGE_MESSAGE = t('membershipChangeCompleted', {
  br: BR_TAG,
});
export const CONTACT_ADMIN_ISSUE = t('contactAdminIfIssue', {
  openingLink: `<a href="home/settings/contact" class="${classNames(
    'skyt',
    'btn'
  )}">`,
  closingLink: '</a>',
});
export const ORIGINAL_MEMBERSHIP = t('previousMembership');
export const CHANGED_MEMBERSHIP = t('newMembership');
export const CHANGED_MEMBERSHIP_DESC = t('changedMembershipDesc', {
  br: BR_TAG,
});
export const CARD_UPDATED_SUCCESS = t('cardInfoUpdated', { br: BR_TAG });
export const CARD_UPDATED_FAIL = t('cardInfoUpdateFailed', { br: BR_TAG });
export const FILES_SCHEDULED_DELETION = t(
  'filesScheduledAutoDeletion',
  colorPointInterpolation
);
export const SCHEDULED_DELETION_DATE = t('scheduledDeletionDate');
export const CHANGED_LOWER_MEMBERSHIP_DESC =
  '※ ' + t('existingMembershipChange');
export const AUTOMATICALLY_DELETE_BY_MEMBERSHIP =
  '※ ' + t('exceedCapacityAutomaticDeletion');
export const CHANGED_UPPER_MEMBERSHIP_DESC =
  '※ ' + t('membershipChangeImmediate', colorPointInterpolation);
export const ADD_PERSONNEL_PAYMENT_DESC =
  '※ ' + t('addManagedPeopleImmediate', colorPointInterpolation);
export const UPDATED_MEMBERSHIP_AMOUNT = t('newMembershipAmount');
export const EXISTING_MEMBERSHIP = t('existingMembership');
export const ORIGINAL_MEMBERSHIP_AMOUNT = t('existingMembershipAmount');
export const MANAGEMENT_PERSONNEL_ADDITIONAL_FEE = t(
  'managedPersonnelAdditionalAmount'
);
export const ENTER_CARD_NUMBER_ALERT = '! ' + t('enterCardNumber');
export const CARD_NUMBER_LENGTH_ALERT = '! ' + t('enterMin15Char');
export const SELECT_CARD_VALID_DATE_ALERT =
  '! ' + t('selectCardExpirationDate');
export const ENTER_BIRTHDATE_ALERT = '! ' + t('enterBirthdate');
export const BIRTHDATE_LENGTH_ALERT = '! ' + t('enterMin6Max10Char');
export const ENTER_PASSWORD_ALERT = '! ' + t('pleaseEnterPassword');
export const PASSWORD_LENGTH_ALERT = '! ' + t('enterFirst2Digits');
export const SELECT_INSTALLMENTS_ALERT = '! ' + t('selectInstallmentPeriod');
export const ENTER_MOBILE_ALERT = '! ' + t('enterMobileNumber');
export const ENTER_NAME_ALERT = '! ' + t('enterName');
export const MOBILE_LENGTH_ALERT = '! ' + t('enterMin10Max11Char');
export const ENTER_EMAIL_ALERT = '! ' + t('enterEmailAlert');
export const EMAIL_FORMAT_ALERT = '! ' + t('enterValidEmail');
export const INSTALLMENTS: StringByKey = {
  '00': PAY_IN_FULL,
  '01': `1${MONTHS}`,
  '02': `2${MONTHS}`,
  '03': `3${MONTHS}`,
  '04': `4${MONTHS}`,
  '05': `5${MONTHS}`,
  '06': `6${MONTHS}`,
  '07': `7${MONTHS}`,
  '08': `8${MONTHS}`,
  '09': `9${MONTHS}`,
  '10': `10${MONTHS}`,
  '11': `11${MONTHS}`,
  '12': `12${MONTHS}`,
} as const;
export const NEXT_PAYMENT_AMOUNT = t('nextPaymentAmount');
export const ADD_PERSONNEL_SUCCESS = t('addManagedPersonnelCompleted', {
  br: BR_TAG,
});
export const ADDED_MANAGEMENT_PERSONNEL = t('addedManagedPersonnel');
export const ADDED_MANAGEMENT_PERSONNEL_DESC = t('addedManagedPersonnelDesc', {
  br: BR_TAG,
});
export const CURRENT_IN_USE = t('currentUse');
export const AMOUNT = t('amount');
export const AMOUNT_DIFFERENCE = t('difference');
export const EMPTY_LIBRARY = t('uploadResourcesForClass');
export const EMPTY_EBOOK = t('noRegisteredEbook');
export const EMPTY_SHARE = t('useOtherTeachersResources');
export const EMPTY_DRIVE = t('storeOtherResources');
export const ITEMS_SELECTED_MESSAGE = t('NItemsSelected', {
  openingSpan: `<span class="${classNames('count')}"><em>`,
  closingSpan: CLOSING_EM_TAG + CLOSING_SPAN,
});
export const SEARCH_RESULT = t('NSearchResults', {
  openingSpan: `<span class="${classNames('count')}">`,
  closingSpan: CLOSING_SPAN,
});
export const SHOW_NOT_SHARED_FILE = t('noSharedFiles');
export const NO_INDEX = t('noTableOfContents');
export const PLACEHOLDER_MEMO = t('enterMemo');
export const SHARE_INFO_GUIDE = t('shareLinkOwnerUrl');
export const MOBILE_FILE_SHARE_GUIDE = t('sharedUserViewOnly');
export const FILE_NOT_SHARED = t('fileIsNotShared');
export const SHARED_WITH_USER = t('sharingWithUsers');
export const END_SHARING = t('ownerEndedShare');
export const PUBLIC_FILE = t('fileIsPublic');
export const NOT_PUBLIC_FILE = t('fileIsNotPublic');
export const FILE_USAGE_SUMMARY = t('usingFileInEbook', {
  openingEm: OPENING_EM_TAG,
  closingEm: CLOSING_EM_TAG,
});
export const FOLDER_USAGE_SUMMARY = t('usingFolderInEbook', {
  openingEm: OPENING_EM_TAG,
  closingEm: CLOSING_EM_TAG,
});
export const ENTER_PASSWORD_FOR_CHANGE = t('enterPasswordForSecure');
export const ENTER_PASSWORD_MESSAGE = t('pleaseEnterPassword');
export const ENTER_PWD = t('enterPasswordLabel');
export const INCONVENIENT_USAGE = t('inconvenientUsage');
export const NOT_OFTEN_USED = t('notUsedOften');
export const FREQUENT_SYSTEM_ERRORS = t('frequentSystemErrors');
export const PRIVACY_SECURITY_CONCERN = t('privacyConcern');
export const WITHDRAWAL_GUIDE = t('accountWithdrawalWarning', { br: BR_TAG });
export const WITHDRAWAL_WARNING = t('accountWithdrawalNoRecovery');
export const WITHDRAWAL_AGREEMENT = t('readAndAgree');
export const PROFILE_CHANGE_COMPLETE = t('userInfoUpdated', { br: BR_TAG });
export const ACCOUNT_DELETE_COMPLETE = t('withdrawalCompletedMessage', {
  br: BR_TAG,
});
export const SHARED_LINK_GUIDE = t('sharedListFromOthers', { br: BR_TAG });
export const STUDENT_REGISTRATION_REQUEST_DESC = t('requestedListFromOthers', {
  br: BR_TAG,
});
export const FEEDBACK_GUIDE = t('sendYourFeedback');
export const NO_FEEDBACK = t('noFeedbackSent');
export const ENTER_TITLE = t('enterTitle');
export const ENTER_CONTENT = t('enterContent');

//Copyright
const OPENING_ANCHOR_TERMS = `<a
    class="${classNames('btn', 'skyt')}"
    href="https://selpub.com/terms#s2024022658a462c854d26"
    target="_blank"
    rel="noopener noreferrer"
    >`;
const CLOSING_ANCHOR = '</a>';
const anchorTerms = {
  openingAnchor: OPENING_ANCHOR_TERMS,
  closingAnchor: CLOSING_ANCHOR,
};
export const COPYRIGHT_INFO = t('copyrightInfo');
export const ATTRIBUTION = t('attribution');
export const SOURCE = t('source');
export const COPYRIGHT_PROTECTION_NOTICE = t('copyrightProtectionNotice');
export const REFER_TO_TERMS_OF_SERVICE = t(
  'referToTermsOfService',
  anchorTerms
);
export const COPYRIGHT_LAW_COMPLIANCE = t('copyrightLawCompliance');
export const INFRINGEMENT_REMOVAL_NOTICE = t('infringementRemovalNotice');
export const LICENSED_MATERIALS_NOTICE = t('licensedMaterialsNotice');
export const HIDE_FOR_TODAY = t('hideForToday ');

export const TOP_NAVIGATION_MENU = {
  notification: NOTIFICATION,
  account: ACCOUNT,
} as const;

export const MAIN_SECTION_LIST = {
  personalList: LIBRARY,
  shareList: SHARED_LIBRARY,
} as const;

export const EMPTY_MSG: StringByKey = {
  library: EMPTY_LIBRARY,
  share: EMPTY_SHARE,
  mydrive: EMPTY_DRIVE,
} as const;

export const OPTION_ICON: StringByKey = {
  grid: t('viewLarge'),
  list: t('viewList'),
  edit: t('editLibrary'),
  info: DETAILS,
} as const;

export const DETAILS_LIST_TITLE: StringByKey = {
  project: EBOOK_INFO,
  projectCopyright: COPYRIGHT_INFO,
  projectIndex: INDEX,
  projectNote: ONE_LINE_MEMO,
  projectResource: FILE_INFO,
  projectShare: FILE_SHARE,
  projectPublic: FILE_RELEASE,
  projectHistoryList: HISTORY,
  resource: FILE_INFO,
  url: URL_INFO,
  share: FILE_SHARE,
  note: ONE_LINE_MEMO,
  useList: USE_INFO,
};

export const EBOOK_INFO_LIST = [
  [TITLE, 'title'],
  [PUBLICATION_DATE, 'pubDate'],
  [PUBLISHER, 'publisher'],
  [AUTHOR, 'author'],
  [PAGE_NUMBER, 'startPage'],
  [COVER, 'orgCoverYn'],
];

export const COPYRIGHT_INFO_LIST = [
  [ATTRIBUTION, 'copyrightOwner'],
  [SOURCE, 'copyrightSource'],
];

export const FILE_INFO_LIST = [
  [`${FILE} ${CATEGORY}`, 'resourceType'],
  [`${FILE} ${SIZE}`, 'totalSize'],
  [`${SELPUB} ${USED_SIZE}`, 'selpubSize'],
  [UPLOADED_DATE, 'regDate'],
  [MODIFIED_DATE, 'uptDate'],
  [SHARED_REG_DATE, 'shareDate'],
];

export const RESOURCE_INFO_LIST = [
  [TITLE_NAME, 'title'],
  [FILE_NAME, 'orgFileName'],
  [LOCATION, 'location'],
  [`${FILE} ${CATEGORY}`, 'ext'],
  [`${SELPUB} ${USED_SIZE}`, 'dispSize'],
  [`${SELPUB} ${USED_SIZE}`, 'selpubSize'],
  [UPLOADED_DATE, 'dispRegDate'],
  [UPLOADED_DATE, 'uploadDate'],
  [DELETED_DATE, 'deleteDate'],
];

export const FOLDER_INFO_LIST = [
  [FOLDER_NAME, 'orgFileName'],
  [`${SELPUB} ${USED_SIZE}`, 'dispSize'],
  [CREATION_DATE, 'dispRegDate'],
];

export const MANAGEMENT_STATUS = t('managementStatus');
export const MANAGEMENT_REQUEST_DATE = t('managementRequestDate');
export const MANAGEMENT_APPROVAL_DATE = t('managementApprovalDate');
export const MANAGEMENT_RELEASE_DATE = t('managementDeactivationDate');

export const CLASSROOM_INFO_FIELDS: ObjectByKey = {
  student: {
    dispStudentStatus: USER_STATUS,
    dispStatus: MANAGEMENT_STATUS,
    dispRequestDate: MANAGEMENT_REQUEST_DATE,
    dispApprovalDate: MANAGEMENT_APPROVAL_DATE,
    dispReleaseDate: MANAGEMENT_RELEASE_DATE,
    email: t('emailInformation'),
    nm: NAME,
    alias: NICKNAME,
    regionTypeNm: REGION,
    schoolTypeNm: SCHOOL_GRADE,
    schoolNm: SCHOOL_NAME,
    gradeTypeNm: GRADE,
    departmentTypeNm: DEPARTMENT,
  },
  group: {
    dispRegDate: t('groupCreationDate'),
    cnt: STUDENT_NUMBER,
    nm: GROUP_NAME,
  },
  teacher: {
    dispTeacherStatus: USER_STATUS,
    dispStatus: MANAGEMENT_STATUS,
    dispRequestDate: MANAGEMENT_REQUEST_DATE,
    dispApprovalDate: MANAGEMENT_APPROVAL_DATE,
    dispReleaseDate: MANAGEMENT_RELEASE_DATE,
    email: EMAIL,
    nm: NAME,
    alias: NICKNAME,
    schoolTypeNm: SCHOOL_GRADE,
    schoolNm: SCHOOL_NAME,
    gradeTypeNm: GRADE,
    subjectTypeNm: SUBJECT,
  },
};

// Footer
export const FOOTER_MENU = {
  Notice: NOTICE,
  // Faq: FAQ,
  PrivacyPolicy: PRIVACY_POLICY,
  Terms: TERMS,
} as const;

export const COPYRIGHT_DESC = t('copyrightNotice');
export const ADDRESS = t('officeAddress');
export const BUSINESS_REGISTRATION_NUMBER = t('businessRegistrationNumber');
export const CEO = t('representativeName');
export const COPYRIGHT = 'Copyright © SELVAS AI Inc. All Rights reserved';

export const FOOTER_LINK = {
  'SELVAS AI': 'https://www.selvasai.com/',
  Selvy: 'https://selvy.ai/',
  Odiro: 'https://www.odiro.ai/',
  'Selvy Speech': 'https://speech.selvasai.com/',
  OnFit: 'http://www.onfit.com/',
  'Selvy Cloud API': 'https://cloud.selvy.ai/front/landing/',
  'Selvy Checkup': 'https://www.selvycheckup.com/',
  'SELVAS Healthcare': 'https://www.selvashealthcare.com/',
};

// Share Link
export const UNAVAILABLE_LINK_MESSAGE = t('unavailableLink');
export const CONTACT_LINK_SHARER = t('contactPersonSharingLink');
export const MOVE_TO_SELPUB = t('moveToSelpub');

// Date Range
export const FROM_DATE_TO_DATE = t('fromDateToDate');
export const TOTAL_TIME_OF_LEARNING = t('totalTimeOfLearning');
export const NOTE_USAGE_TIME_DETAILS_IN_TITLE = t(
  'noteUsageTimeDetailsInTitle',
  activitySummaryInterpolation0
);
export const LAST_PAGE = t('lastPage');

export const STATUS_REVIEW = t('statusReview');
export const STATUS_REQUEST = t('statusRequest');
export const STATUS_COMPLETE = t('statusComplete');
